import styled from '@emotion/styled';
import { tokens } from '@hotjar/hotsauce';

import { NavList } from '@hotjar/navigation/src/components/NavDropdown';
import { SiteItem } from './SiteItem';
import type { Organization, Site } from '@hotjar/navigation/src/types';

import { useNavigation } from '@hotjar/navigation/src/hooks/useNavigation';

interface OrganizationSiteListProps {
  className?: string;
  organization: Organization;
  selectedSiteId?: number;
  siteHrefRoute: string;
  siteHrefArgs: Record<string, string>;
  onSelect: (site: Site) => void;
  demoSiteItem?: {
    isLoading: boolean;
    id: number;
  };
}

const OrganizationTitle = styled.div`
  padding: ${tokens.spacer.x2} ${tokens.spacer.x2} ${tokens.spacer.x0};
  ${tokens.text('subtitle3')};
  color: ${tokens.color.text_disabled};
`;

export const OrganizationSiteList = ({
  className,
  organization,
  selectedSiteId,
  siteHrefRoute,
  siteHrefArgs,
  onSelect,
  demoSiteItem,
}: OrganizationSiteListProps): JSX.Element => {
  const { buildHrefFromRoute } = useNavigation();

  const sites = organization.sites.map((site) => (
    <SiteItem
      isLoading={demoSiteItem?.isLoading && demoSiteItem?.id === site.id}
      key={site.id}
      site={site}
      isSelected={selectedSiteId === site.id}
      href={buildHrefFromRoute(siteHrefRoute, { siteId: site.id, ...siteHrefArgs })}
      onClick={() => {
        onSelect(site);
      }}
      as={demoSiteItem?.id === site.id ? 'button' : undefined}
    />
  ));

  return (
    <li className={className}>
      <OrganizationTitle>{organization.name}</OrganizationTitle>
      <NavList>{sites}</NavList>
    </li>
  );
};

OrganizationSiteList.displayName = 'OrganizationSiteList';
